<template>
  <div class="add_new_inner wrap-surg-add">
    <div class="subtitle center no_mobile">
      לשם עדכון הצוות בחדר ניתוח, אנא פרט באילו משתלים תשתמש
    </div>
    <h2 class="subtitle_inner mobile_only">
      לשם עדכון הצוות בחדר ניתוח, אנא פרט באילו משתלים תשתמש:
    </h2>
    <div class="required-txt desk-center">
      *כוכבית מסמלת את השדות הנדרשים לבחירה
    </div>

    <ValidationObserver ref="implantsForm">
      <form @submit.prevent="onSubmit" name="implantsForm">
        <div
          class="inner_group bg--white desk_inner_width desk-flex desk-flex--top sanit-form"
        >
          <div class="add_new_row flex intro-implants">
            <div class="add_new_row_col1">
              האם יוזמנו משתלים יעודיים לניתוח?
            </div>
            <div class="add_new_row_col2">
              <div class="input-opacity desk-block">
                <validation-provider
                  ref="isImplants"
                  name="isImplants"
                  rules=""
                  v-slot="{ errors }"
                >
                  <select2 dir="rtl" v-model="isImplants">
                    <option value="">בחר</option>
                    <option :value="true">כן</option>
                    <option :value="false">לא</option>
                  </select2>
                  <span class="error-message">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="is-implants-note required-txt">
              * רופא/ה יקר/ה, לתשומת ליבך: ב-6.9 שדה זה יוגדר כשדה חובה. נודה על
              מילויו כבר מעתה, לשם היערכות מיטבית של הצוותים לקראת הניתוח.
            </div>
          </div>

          <template v-for="(implantEntry, index) in formData.implantsData">
            <div
              v-if="isImplantsEnabled"
              :key="`implant_${index}`"
              class="add_new_row flex"
            >
              <div class="add_new_row_col1">
                איזו חברה הוזמנה?*
                <span v-if="formData.implantsData.length > 1">
                  (חברה מס' {{ index + 1 }})
                </span>
              </div>
              <div class="add_new_row_col2">
                <div class="input-opacity desk-block">
                  <validation-provider
                    :ref="`tmpImplant_${index}`"
                    :name="`tmpImplant_${index}`"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <select2
                      dir="rtl"
                      :value="implantEntry.supplier_id"
                      @input="handleImplantChange($event, index)"
                    >
                      <option value="">בחר</option>
                      <option
                        v-for="item in implantsList"
                        :key="item.supplier_id"
                        :value="item.supplier_id"
                      >
                        {{ item.supplier_name }}
                      </option>
                      <option value="other">אחר</option>
                    </select2>
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>

            <div
              v-if="isImplantsEnabled && implantEntry.supplier_id === 'other'"
              :key="`implantName_${index}`"
              class="add_new_row flex"
            >
              <div class="add_new_row_col1">שם החברה*</div>
              <div class="add_new_row_col2">
                <div class="input-opacity desk-block">
                  <validation-provider
                    :ref="`implantName_${index}`"
                    :name="`implantName_${index}`"
                    :rules="
                      implantEntry.supplier_id === 'other' ? 'required' : ''
                    "
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      v-model="implantEntry.implantName"
                      :disabled="implantEntry.supplier_id !== 'other'"
                    />
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div
              v-else
              :key="`implantName_${index}_disabled`"
              class="add_new_row flex no_mobile"
            ></div>

            <div
              v-if="implantAddMoreSectionVisible[index]"
              :key="`addMore_${index}`"
              class="add_new_row flex"
            >
              <div class="add_new_row_col1">האם הוזמנה חברה נוספת?</div>
              <div class="add_new_row_col2">
                <div class="input-opacity desk-block">
                  <select2
                    dir="rtl"
                    :key="`add_more_${formData.implantsData.length}`"
                    :value="addMoreCompanies[index]"
                    @input="handleUpdateAddMore($event, index)"
                  >
                    <option value="">בחר</option>
                    <option :value="true">כן</option>
                    <option :value="false">לא</option>
                  </select2>
                </div>
              </div>
            </div>
          </template>

          <div
            v-if="hasAtLeastOneCompany"
            class="add_new_row flex"
            style="flex-basis: 100%"
          >
            <div class="add_new_row_col1">
              לשם עדכון הצוות בחדר ניתוח, אנא פרטי באילו משתלים תשתמש
            </div>
            <div class="add_new_row_col2">
              <div class="input_area_opcity">
                <textarea
                  v-model="formData.implants_resources"
                  placeholder="פירוט..."
                  autocomplete="off"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="surg-bottom-actions center">
          <button type="submit" class="bt_blue">הבא</button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  getGeneralResources,
  getImplantsResources,
  combineResources
} from "@/utilities/resources-separator";
import { setTutorial } from "@/utilities/intro.js";

const MAX_IMPLANTS = 10;

export default {
  name: "ImplantsSuppliers",
  data() {
    return {
      formData: {
        implantsData: [],
        implants_resources: ""
      },
      isImplants: "",
      addMoreCompanies: []
    };
  },
  computed: {
    ...mapState("Surgery", ["surgery", "implantsList"]),
    isImplantsEnabled() {
      return this.isImplants === true || this.isImplants === "true";
    },
    implantAddMoreSectionVisible() {
      const rows = this.formData.implantsData;
      const len = rows.length;
      if (!len || len >= MAX_IMPLANTS) {
        return rows.map(() => false);
      }
      return rows.map((entry, index) => {
        if (index < len - 1) return true;
        if (entry.supplier_id === "other") {
          return !!(entry.implantName && String(entry.implantName).trim());
        }
        return entry.supplier_id !== "" && entry.supplier_id != null;
      });
    },
    hasAtLeastOneCompany() {
      if (!this.isImplantsEnabled || !this.formData.implantsData?.length) {
        return false;
      }
      return this.formData.implantsData.some(entry => {
        const id = entry.supplier_id;
        if (id === "" || id == null) return false;
        if (id === "other") {
          return !!(entry.implantName && String(entry.implantName).trim());
        }
        return true;
      });
    }
  },
  watch: {
    hasAtLeastOneCompany(val) {
      if (!val) {
        this.formData.implants_resources = "";
      }
    },
    isImplants(newValue) {
      if (newValue === true || newValue === "true") {
        if (!this.formData.implantsData?.length) {
          this.formData.implantsData = [
            { supplier_id: "", generic_item_id: null, implantName: "" }
          ];
          this.addMoreCompanies = [""];
        }
      } else {
        this.formData.implantsData = [];
        this.addMoreCompanies = [];
        this.formData.implants_resources = "";
      }
    }
  },
  created() {
    this.formData.implantsData = this.surgery.implantsData?.length
      ? [...this.surgery.implantsData]
      : [];
    this.formData.implants_resources = getImplantsResources(
      this.surgery.resources
    );

    if (this.formData.implantsData.length) {
      this.isImplants = "true";
      this.addMoreCompanies = this.formData.implantsData.map((_, i) =>
        i < this.formData.implantsData.length - 1 ? "true" : ""
      );
    }
    if (!this.hasAtLeastOneCompany) {
      this.formData.implants_resources = "";
    }
  },
  mounted() {
    this.setTutorial(
      "intro-implants",
      `רופא/ה יקר/ה,

החל מ־6.9.26, בניתוחים המצריכים משתל יש לעדכן באפליקציה האם נדרש משתל ולבחור את כל החברות שמהן הוזמן ציוד לניתוח.

המידע נדרש לצורך היערכות מחלקת אספקה סטרילית וצוות חדר הניתוח.

חשוב: ציוד מחברה שלא נבחרה באפליקציה לא יוכל להתקבל במחלקת אספקה סטרילית.

אנא הקפידו על עדכון מלא בעת הזמנת הניתוח.`
    );
  },
  methods: {
    ...mapMutations("Surgery", ["SET_SURGERY", "SET_CURRENT_STEP"]),
    setTutorial,
    handleUpdateAddMore(value, index) {
      const isTrue = value === true || value === "true";
      const isFalse = value === false || value === "false";

      this.$set(this.addMoreCompanies, index, value);

      if (isTrue && index === this.formData.implantsData.length - 1) {
        this.formData.implantsData.push({
          supplier_id: "",
          generic_item_id: null,
          implantName: ""
        });
        this.addMoreCompanies.push("");
      } else if (isFalse && index < this.formData.implantsData.length - 1) {
        this.formData.implantsData.splice(index + 1);
        this.addMoreCompanies.splice(index + 1);
      }
    },
    handleImplantChange(value, index) {
      if (this.formData.implantsData[index] === undefined) return;

      const supplier = this.implantsList.find(s => s.supplier_id === value);
      this.$set(this.formData.implantsData, index, {
        supplier_id: value,
        generic_item_id: supplier?.generic_item_id ?? null,
        implantName:
          value === "other" ? this.formData.implantsData[index].implantName : ""
      });
    },
    async onSubmit() {
      const isValid = await this.$refs.implantsForm.validate();

      if (!isValid) {
        this.scrollToFirstError();
        return;
      }

      this.SET_SURGERY({
        implantsData: this.formData.implantsData,
        resources: combineResources(
          getGeneralResources(this.surgery.resources),
          this.formData.implants_resources
        )
      });
      this.SET_CURRENT_STEP(6);
    },
    scrollToFirstError() {
      const HEADER_OFFSET = 120;
      const errors = this.$refs.implantsForm.errors;

      for (const fieldName in errors) {
        if (errors[fieldName].length > 0) {
          const ref = this.$refs[fieldName];
          const element = Array.isArray(ref) ? ref[0]?.$el : ref?.$el;

          if (element) {
            const elementTop =
              element.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({
              top: elementTop - HEADER_OFFSET,
              behavior: "smooth"
            });
          }
          break;
        }
      }
    }
  }
};
</script>

<style scoped>
.intro-implants {
  flex-wrap: wrap;
}

.is-implants-note {
  flex-basis: 100%;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 1.35;
  text-align: right;
  padding: 6px 0 10px;
  margin: 0;
}

@media screen and (min-width: 1200px) {
  .intro-implants .add_new_row_col2 {
    margin-bottom: 4px;
  }

  .is-implants-note {
    font-size: 18px;
    padding: 2px 0 16px;
  }
}
</style>
